import axios from "axios";
import React, { ChangeEvent } from "react";

import { apiUrl } from "../../config";
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { displayField, getRootComponent } from "../../utilities/ElementUtils";
import XMLParser from "../../utilities/XMLParser";
import SectionUtils from "../../utilities/SectionUtils";
import Utils from "../../utilities/Utils";
import { SCRIPT_ENV } from "../../config/RuntimeConfig";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import CustomPopup from "./PopupComponent";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
  showPopup: boolean;
  pendingSelection: { lov: LOVValues; value: string } | null;
}

export class RadioWithRichTextComponent extends React.Component<Props, State> {
  HtmlToReactParser = require('html-to-react').Parser;
  constructor(props: Props) {
    super(props);

    let field = this.props.field;
      this.state = {
          showPopup: false,
          pendingSelection: null
      };
    FormValidationUtils.runJavascript(field);
  }

  async componentDidMount(): Promise<void> {
    const field = this.props.field;

    if (field.LovAPI) {

        const getUrl = field.LovAPI;
        let response;

        if (getRootComponent(field).UseProxy == "Y") {
            let transferPayload = {
                url: getUrl,
                httpMethod: 'GET',
                payload: ""
            }

            response = await axios.post(apiUrl() + "/tponTransfer", transferPayload);

        } else {
            response = await axios.get(getUrl);
        }
        field.ListOfLOVValues = response.data;
        this.reconcilePreBoundValueWithLovOptions(field);
        this.props.callbackElement(getRootComponent(field));
    }
  }

  reconcilePreBoundValueWithLovOptions = (field: FormSectionElements): void => {
    const currentValue = field.Value;
    if (currentValue === undefined || currentValue === null) return;

    const currentValueTrimmed = String(currentValue).trim();
    if (!currentValueTrimmed) return;

    const list = field.ListOfLOVValues ?? [];
    const codeMatch = list.find((opt) => String(opt?.code ?? '').trim() === currentValueTrimmed);
    if (codeMatch) {
      field.SelectionCode = codeMatch.code;
      return;
    }

    const normalizedCurrentValue = currentValueTrimmed.toLowerCase();
    const descMatch = list.find((opt) => {
      const description = String(opt?.description ?? opt?.name ?? '').trim().toLowerCase();
      const fraDescription = String(opt?.FRADescription ?? opt?.nameFrench ?? '').trim().toLowerCase();
      return description === normalizedCurrentValue || fraDescription === normalizedCurrentValue;
    });

    if (descMatch) {
      field.Value = descMatch.code;
      field.SelectionCode = descMatch.code;
    }
  }
  
  getGaTrackingId = () => {
    let section = this.props.field.parent;
    let trackingId = '';
    while (section && !section.GATrackingID) {
        section = section.parent;
    }

    return section?.GATrackingID;
  }

  isValueFilled = (v: unknown): boolean => {
    if (v === undefined || v === null) return false;
    return String(v).trim() !== '';
  };

  applyRadioSelection = (lov: LOVValues, value: string) => {

    let field = this.props.field;
    
    // field.SelectionCode = this.props.isEng ? lov.code : lov.FRA;
    field.Value = value;
    field.SelectionCode = value;
    if (field.UpdateField) {
      let subsec = field.parent as FormSubSections;
      subsec.ListOfFormSectionElements.forEach(ele => {
        if (ele.LoadBindName == field.UpdateField){
          ele.Value = value;
          ele.SelectionCode = value;
        }
      })
    }
    // field.Touched = true;
    // field.IsEmpty = false;
    
    // // Clear error messages when a selection is made
    // field.EmptyErrorMessage = null;
    // field.EmptyErrorMessageFRA = null;
    // field.ErrorMessage = null;
    // field.ErrorMessageFRA = null;
    
    FormValidationUtils.validateRadioButton(field);
    FormValidationUtils.runJavascript(field);

    if (field.EventScript) {
      const functions = {
          resetFieldValues: ((field: FormSectionElements, exceptFields?: string[]) => SectionUtils.resetAllFieldValues(field, exceptFields)),
      }
      try {
        const customEventFunc = eval(`(${field.EventScript})`);
        if (typeof customEventFunc === 'function') {
          customEventFunc(field, SCRIPT_ENV, functions);
        }
      } catch (ex) {
        console.log(ex);
      }
    }
    // // Force validation state update
    // if (field.Optional === 'N' && !field.Value) {
    //   field.Valid = false;
    //   field.Touched = true;
    //   field.IsEmpty = true;
    // } else {
    //   field.Valid = true;
    //   field.IsEmpty = false;
    // }

    this.props.callbackElement(getRootComponent(field));
  }

    setSelectedRadio = (lov: LOVValues, value: string) => {
    const field = this.props.field;
    if (field.ReadOnly) return;

    const previousValue = field.Value;
    const showPopupOnChange = !!field.ShowPopup &&
      this.isValueFilled(previousValue) &&
      this.isValueFilled(value) &&
      String(previousValue) !== String(value);

    if (showPopupOnChange) {
      this.setState({ showPopup: true, pendingSelection: { lov, value } });
      return;
    }

    this.applyRadioSelection(lov, value);
  }

  handlePopupConfirm = () => {
    if (this.state.pendingSelection) {
      this.applyRadioSelection(this.state.pendingSelection.lov, this.state.pendingSelection.value);
    }
    this.setState({ showPopup: false, pendingSelection: null });
  }

  handlePopupCancel = () => {
    this.setState({ showPopup: false, pendingSelection: null });
  }


  parseOptionRichText = (lov: LOVValues) => {   
    if (this.props.isEng && !lov.richText) return null;
    if (!this.props.isEng && !lov.richTextFRA) return null;
    let reactNode = Utils.parseRichTextIntoReact(this.props.isEng ? lov.richText: lov.richTextFRA)
    return reactNode;
  }

  isOptionVisible = (lov: LOVValues): boolean => {
    if (lov.FilterField != null && lov.FilterField.length > 0) {
      let filterValue;

      let toDisplay = [];

      let filterField = [];

      if (Array.isArray(lov.FilterField)) {
        filterField.push(...lov.FilterField)
      } else {
        filterField.push(lov.FilterField)
      }

      filterField.forEach((fieldName) => {


        let foundFilterField = XMLParser.findSubSectionElement(this.props.field, fieldName);
        try {
          if (foundFilterField != null && lov.FilterValue) {
            filterValue = foundFilterField.Value;



            let fieldValue = lov.FilterValue[foundFilterField.LoadBindName];

            if (fieldValue) {
              if (fieldValue.length > 0 && fieldValue?.indexOf(filterValue) == -1) {
                toDisplay.push(false);
              } else {
                toDisplay.push(true);
              }
            }
          }
        } catch (ex) {
          console.log(ex);
        }

      })

      return (toDisplay.filter(p => p == false).length == 0);

    }

    return true;
  }

  generateOptions = (lovList: LOVValues[]) => {
    let field = this.props.field;
    
    FormValidationUtils.runJavascript(field);
    if (!field.Visible) return null;

    let htmlString = [];

    lovList.forEach(lov => {

        htmlString.push(
            <div key={`radio_${field.Id}_${lov.code}`} className="ontario-radios__item">
                <input key={`input_${field.Id}_${lov.code}`}
                    className={field.Valid ? "ontario-radios__input" : "ontario-radios__input ontario-radios__error"} 
                    onChange={() => this.setSelectedRadio(lov, String(lov.code))}
                    name={field.LoadBindName}
                    id={field.LoadBindName + lov.code}
                    type="radio"
                    aria-invalid={(!field.Valid && field.Touched && lov.Sequence==undefined) ? "true" : undefined}
                    value={lov.code}
                    checked={field.SelectionCode == (lov.code)}></input>
                <label key={`label_${field.Id}_${lov.code}`}
                    className="ontario-radios__label" 
                    htmlFor={field.LoadBindName + lov.code}
                    >
                    {this.parseOptionRichText(lov)}
                </label>
            </div>
        );
    })

    return htmlString;
  }

  generateHtml = () => {
    let field = this.props.field;
    let displayfield: boolean = true;
    displayfield = displayField(field);
    field.Visible = displayfield;
    FormValidationUtils.runJavascript(field)
    if (!field.Visible) return null;

    let controlArrayHtml = [];
 
   
    let editable = this.props.editable;

    let title = this.props.title;
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;
    const marginBottom = Utils.getSpacingValue(field.MarginBottom);
    const marginTop = Utils.getSpacingValue(field.MarginTop);
    const containerStyle: React.CSSProperties = {};
    if (marginBottom !== undefined) containerStyle.marginBottom = marginBottom;
    if (marginTop !== undefined) containerStyle.marginTop = marginTop;

    if (editable) {
      var lovCheckList: LOVValues[] = [];
      field.ListOfLOVValues.forEach(lov => {
        if (this.isOptionVisible(lov)) lovCheckList.push(lov);
      });

      if (field.FilterField != null) {
        let parts = field.FilterField.split('.');
        let baseName;
        let bindName;
        if (parts.length == 3) {
          baseName = parts[0] + '.' + parts[1];
          bindName = parts[2];
        }
        if (parts.length == 2) {
          baseName = parts[0];
          bindName = parts[1];
        }
        if (parts.length == 1) {
          baseName = '';
          bindName = parts[0];
        }

        let subSection: FormSubSections = field.parent as FormSubSections;
        let foundFilterFields = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == bindName);
        let foundFilterField;
        if (foundFilterFields.length == 1)
          foundFilterField = foundFilterFields.at(0);
        if (field.FilterValue == 'exclude' && lovCheckList != null && foundFilterField != null && foundFilterField.Value != null) {
          lovCheckList = lovCheckList.filter(p => foundFilterField.Value.indexOf(p.code) == -1);
        }
      }

      if (lovCheckList.length > 0) {
         

        controlArrayHtml.push(
        <fieldset className="ontario-fieldset" style={containerStyle} aria-describedby={field.Valid ? undefined : `${field.LoadBindName}-${field.Id}-error`}>
        {this.props.labelControlArray}
          <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>
            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />
            
             <div className="ontario-radios">
                {this.generateOptions(lovCheckList)}
             </div>
          </div>
          </fieldset>
          )
      }
    } else {
      let lovValue = field.ListOfLOVValues.find(lov => lov.code == field.Value);
      controlArrayHtml.push(
        <div className='pdf-two-column' style={containerStyle}>
          <div>{title}</div>
          <div>{this.parseOptionRichText(lovValue)}</div>
        </div>
      );
    }

        const popupTitle = this.props.isEng
      ? (this.props.field.PopupTitle || 'Confirm')
      : (this.props.field.PopupTitleFRA || 'Confirmer');
    const popupMessage = this.props.isEng
      ? (this.props.field.PopupMessage || '')
      : (this.props.field.PopupMessageFRA || '');
    const confirmLabel = this.props.isEng ? 'Confirm' : 'Confirmer';
    const cancelLabel = this.props.isEng ? 'Cancel' : 'Annuler';

    if (this.state.showPopup && this.state.pendingSelection) {
      controlArrayHtml.push(
        <CustomPopup
          key="radio-popup"
          isVisible={this.state.showPopup}
          title={popupTitle}
          closable={true}
          handleModalClose={this.handlePopupCancel}
          customClass="custom-popup"
        >
          <div className="popup-content">
            <p>{popupMessage ? (new this.HtmlToReactParser()).parse(popupMessage) : null}</p>
            <div className="popup-buttons">
              <button
                className="ontario-button ontario-button--primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.handlePopupConfirm();
                }}
              >
                {confirmLabel}
              </button>
              <button
                className="ontario-button ontario-button--secondary"
                onClick={(e) => {
                  e.preventDefault();
                  this.handlePopupCancel();
                }}
              >
                {cancelLabel}
              </button>
            </div>
          </div>
        </CustomPopup>
      );
    }

    return controlArrayHtml;
  }


  render() {
    return  this.generateHtml()
  }
}
